import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rv_lang") || "it");

  useEffect(() => {
    localStorage.setItem("rv_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => setLang((p) => (p === "it" ? "en" : "it")), []);

  const value = useMemo(
    () => ({ lang, setLang, toggle, t: translations[lang] }),
    [lang, toggle]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
